import React from 'react';
import { parseMarkdown } from '../../utils/helper';
export const OverallSkills = ({ data }) => {
    return (
        <div className="overall-skills-div-v2 break-stop">
            <div className="candidate-skills-wrapper-v2">
                <span className="candidate-skills-heading candidate-skill-flex">
                    <div className="resume-summary-text">Resume Summary</div>
                </span>
                <div className="font-style-soft-skill resume-summary text-start ps-3">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: parseMarkdown(
                                data?.resumeSummary || 'No valid candidate information provided in the resume.'
                            ),
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
